import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationButtonsComponent } from './pagination-buttons.component';
import { StackModule } from '../stack/stack.module';
import { ButtonModule } from '../button/button.module';
import { PaginationButtonModule } from './pagination-button.module';

@NgModule({
  declarations: [PaginationButtonsComponent],
  imports: [CommonModule, StackModule, ButtonModule, PaginationButtonModule],
  exports: [PaginationButtonsComponent],
})
export class PaginationButtonsModule {}
